export default __webpack_public_path__ + "static/card-3-a6eeb6248092fdb0c5070b88343e2cf1.png";